var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FastDownload50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8eaf6",
    d: "M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2ff59",
    d: "M25.72,22.98c0.27,0.45,0.35,1,0.22,1.52c-0.05,0.18-0.12,0.34-0.22,0.5H22.3 c-0.25-0.45-0.31-0.97-0.18-1.47c0.13-0.52,0.48-0.97,0.94-1.25c0.31-0.17,0.65-0.26,0.98-0.26C24.71,22.02,25.36,22.36,25.72,22.98 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fb8c00",
    d: "M26.45,17.44c0.37,0.13,0.73,0.3,1.08,0.51c1.1,0.64,1.98,1.54,2.57,2.62l8.92-6.48 c-2.16-3.28-5.38-5.81-9.17-7.11L26.45,17.44z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#64dd17",
    d: "M6,24c0,0.17,0,0.33,0.01,0.5c0,0.17,0.01,0.33,0.03,0.5h8.97c1.02,0,1.86-0.78,1.98-1.8 c0.11-0.92,0.41-1.83,0.89-2.65l-8.9-6.46C7.1,16.93,6,20.34,6,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2ff59",
    d: "M8.98,14.09l8.9,6.46c0.01-0.03,0.03-0.07,0.05-0.1c0.85-1.45,2.15-2.47,3.62-3.01l-3.4-10.46 C14.36,8.28,11.14,10.81,8.98,14.09z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M18.15,6.98l3.4,10.46c1.55-0.57,3.3-0.6,4.9,0l3.4-10.46C28.02,6.34,26.05,6,24,6 S19.98,6.34,18.15,6.98z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M30.1,20.57c0.3,0.52,0.53,1.08,0.68,1.67c0.08,0.32,0.15,0.65,0.18,0.97 c0.12,1.02,0.96,1.79,1.98,1.79h9.02c0.02-0.17,0.03-0.33,0.03-0.5C42,24.33,42,24.17,42,24c0-3.66-1.1-7.07-2.98-9.91L30.1,20.57z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M24.579,26.432l10.153-3.959c0.52-0.203,0.776-0.788,0.574-1.307c-0.168-0.43-0.599-0.68-1.037-0.638 l-10.847,1.041c-1.388,0.133-2.405,1.366-2.271,2.754c0.133,1.388,1.366,2.405,2.754,2.271 C24.136,26.571,24.37,26.512,24.579,26.432z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M22.469,21.41c-1.426,0.838-1.893,2.672-1.05,4.101c0.848,1.434,2.684,1.913,4.112,1.079 c1.426-0.834,1.893-2.672,1.046-4.101C25.734,21.06,23.895,20.572,22.469,21.41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4dd0e1",
    d: "M23.512,23.145c-0.477,0.277-0.633,0.895-0.352,1.371c0.285,0.48,0.906,0.641,1.383,0.359 c0.48-0.277,0.637-0.891,0.355-1.371C24.613,23.027,23.992,22.867,23.512,23.145"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#78909c",
    d: "M26.646,33.354c-0.818-0.756-1.425-1.486-2.2-1.895C23.697,31.03,22.862,30.924,22,31 c-0.552,0.048-1.039-0.36-1.088-0.912c-0.048-0.552,0.36-1.039,0.912-1.088c0.051-0.004,0.101-0.005,0.151-0.002L22,29 c1.159,0.079,2.384,0.466,3.297,1.223c0.929,0.727,1.489,1.709,2.056,2.423l0.023,0.029c0.172,0.216,0.136,0.53-0.08,0.702 C27.101,33.533,26.824,33.518,26.646,33.354z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M25.646,33.354c-0.709-0.614-1.38-1.058-2.162-1.24C22.709,31.919,21.858,31.922,21,32 c-0.552,0.05-1.041-0.357-1.091-0.909S20.266,30.05,20.818,30c0.059-0.005,0.124-0.005,0.182,0c0.995,0.09,2.025,0.262,3.001,0.705 c0.992,0.429,1.779,1.222,2.352,1.941l0.013,0.016c0.172,0.216,0.137,0.532-0.08,0.704C26.095,33.519,25.825,33.509,25.646,33.354z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M23,41l-0.014-1.134l2.237-2.858l2.419-0.61C27.535,38,27,39,26,40s-2,1-2,1H23z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#546e7a",
    d: "M18.538,35.429c-0.069-0.02-0.138-0.041-0.207-0.066c-0.42-0.153-0.781-0.369-1.078-0.625 c-0.255-0.219-0.46-0.469-0.609-0.737c-0.301,0.226-0.521,0.532-0.593,0.893C15.642,36.94,17.765,38,18.949,38 c0.001,0,0.022-0.001,0.051-0.002C18.489,37.241,18.303,36.359,18.538,35.429z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M26.02,38.688c-1.572,1.216-3.747,1.689-5.597,0.98c-1.85-0.706-2.903-2.44-2.206-4.317 C18.74,33.944,19.605,33,21,33c2,0,2,1,3,1c0.279,0.107,1.381-0.142,1.495-0.452C27.818,33.416,29.479,34.782,26.02,38.688z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#78909c",
    d: "M29.872,34.536c-0.345,0.93-2.438,0.227-3.491-0.078s-1.626-1.306-1.281-2.236 s1.479-1.437,2.532-1.132C28.685,31.394,30.497,32.851,29.872,34.536z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,32c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5S27.776,32,27.5,32z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M23.083,40.681L24,42h2v-0.645c0,0,0-1.355-1.167-1.355L23.083,40.681z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M21.892,35.185C24.394,36.573,23.929,39.11,21,40c0,0,0.626-0.641-1.167-1.338 c-1.214-0.472-1.848-1.651-1.024-2.813C19.477,34.905,20.757,34.544,21.892,35.185z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M24,42c0.223-0.366,1.367-1.776,1-2l-2.8-0.372c-0.367-0.222,0.567-2.798,0.567-2.798L21,40L24,42z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M18.69,29c-0.27,0.29-0.47,0.63-0.6,1H14l1-1H18.69z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M18.08,32H13l1-1h3.91c0,0.09,0,0.18,0.01,0.27C17.94,31.53,18,31.77,18.08,32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FastDownload50);
export default __webpack_public_path__ + "static/media/icons8-fast-download-50.992e73b8a803ef5682d9d00f24944927.svg";
export { ForwardRef as ReactComponent };